import React from 'react';
import { Card } from 'antd';
import { useFetchUrlClustersQuery } from './service';
import UrlClustersTable from './UrlClustersTable';


type Props = {
    websiteGuid: string;
};


export default function UrlClusters({ websiteGuid }: Props) {
    const { data: clusters, isLoading } = useFetchUrlClustersQuery({ w_guid: websiteGuid });

    return (
        <Card
            className="deep-analysis-url-clusters"
            loading={isLoading}
            title={
                <div className="ant-card-meta-detail">
                    <div className="ant-card-meta-title">Page Groups</div>
                </div>
            }
        >
            {clusters && <UrlClustersTable clusters={clusters} />}
        </Card>
    );
}
